/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState, useEffect, useContext } from 'react';
import { getCredentialUploadTasksForUser } from 'blb-api/users';
import { DashboardSection } from '../DashboardPage/DashboardSection';
import { getPendingTasks } from '../DashboardPage/Task/taskUtils';
import { MeContext } from 'blb-contexts/Me';
import { BlendBridge } from 'blb-types/blendBridge';

export namespace CredentialUpload {
  export interface Props {}
}

export const CredentialUpload: React.FC<CredentialUpload.Props> = ({}) => {
  const [credentialTasks, setCredentialTasks] = useState<BlendBridge.API.Task[] | undefined>(undefined);
  const me = useContext(MeContext);

  const fetchCredentialTasks = async () => {
    // TODO: filter to only include tasks that have PROFILE_CREDENTIALS in their views array
    const { data: tasks } = await getCredentialUploadTasksForUser(me!.principalId);
    setCredentialTasks(tasks);
    return tasks;
  };

  useEffect(() => {
    fetchCredentialTasks();
  }, []);

  return (
    <>
      <DashboardSection
        // TODO: Convert getPendingTasks args into options object to remove need for undefined
        sectionConfigs={getPendingTasks(
          fetchCredentialTasks,
          'notary',
          credentialTasks,
          undefined,
          undefined,
          'PROFILE_CREDENTIALS',
        )}
        sectionHeader="Credentials"
      />
    </>
  );
};
